var $ = require('jquery')

module.exports = function(options) {
  options = options || {}

  $(function() {
    var TOPBAR_HEIGHT = options.topbarHeight || 45
      , rHash = /^#.+/
      , jumpToTargetElement = function(idHash) {
          var toElement = $(idHash)
          if (!toElement.length) { return }
          window.scroll(0, toElement.offset().top - TOPBAR_HEIGHT)
        }

    $(window).on('hashchange', function(e) {
      var idHash = window.location.hash
      if (!idHash) { return }
      jumpToTargetElement(idHash)
    })

    $(document).on('click', 'a[href^="#"]', function(e) {
      var el = $(e.currentTarget)
        , hash = el.attr('href')

      if (!hash || !rHash.test(hash) || hash !== window.location.hash) {
        return
      }

      e.preventDefault()

      jumpToTargetElement(hash)
    })
  })
};
